import * as Period from 'constants/Period';

const WHATWHEREWHEN_PERIOD_MAP = {};
WHATWHEREWHEN_PERIOD_MAP[2800] = Period.NOT_STARTED;
WHATWHEREWHEN_PERIOD_MAP[2801] = Period.FIRST;
WHATWHEREWHEN_PERIOD_MAP[2802] = Period.FINISHED;

export default WHATWHEREWHEN_PERIOD_MAP;


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/WhatWhereWhen/PeriodMap.js